/*
 * Copyright (c) Ekathva Innovations Private Limited- All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * Proprietary and confidential
 *
 * Author: Nikitha S Bhatt (nikitha@ekathvainnovations.com), Akshay K Kulkarni (akshay.kulkarni@ekathvainnovations.com)
 *
 * Date:08-06-2021
 *
 * Filename: ContactUsPage
 * Page name: contact-us
 * Page Description: This is the contact us page of the website of Ekathva Innovations.
 */

import React, { Component } from "react";
import MetaTags from "react-meta-tags";
import { Row, Col, Media, Button, Container, Modal } from "react-bootstrap";
import LandingPageContact from "components/Headers/LandingPageContact";
import Footer from "components/Footers/Footer";
import Navbar from "components/Navbars/Navbar";
import { Formik, Form } from "formik";
import Validation from "../Validation.js";
import ApiService from "../api/ApiService.js";
import { Input } from "reactstrap";

import "assets/style/Style.css";
import successImage from "assets/images/AllPage/list.png";
import failureImage from "assets/images/AllPage/into.png";

import SI from "assets/images/HeaderImages/SI.png";
import SK from "assets/images/HeaderImages/SK.png";
import DS from "assets/images/HeaderImages/DS.jpeg";
import Anvesana from "assets/images/HeaderImages/Anvesana.jpeg";
import JNNCE from "assets/images/Clients/Jnnce.jpg";
import { ReactComponent as Office } from "assets/images/ContactUs/Office.svg";
import { ReactComponent as Phone } from "assets/images/ContactUs/Phone.svg";
import { ReactComponent as Email } from "assets/images/ContactUs/Email.svg";

class ContactUsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_success: false,
      modal_failure: false,
      name: "",
      emailAddress: "",
      contactNumber: "",
      message: "",
    };

    this.onContactSubmit = this.onContactSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  componentDidMount() {
    // this is needed, because InfiniteCalendar forces window scroll
    window.scrollTo(0, 0);
  }

  toggle = (modalType) => () => {
    console.log("inside toggle");
    if (!modalType) {
      return this.setState({ modal: !this.state.modal });
    }
    this.setState({
      [`modal_${modalType}`]: !this.state[`modal_${modalType}`],
    });
  };

  handleChange(event) {
    const target = event.target;
    const name = target.name;
    let value = event.target.value;
    this.setState({ [name]: value });
  }

  onKeyPressTextOnly(event) {
    if (event.charCode !== 32) {
      Validation.onKeyPressTextOnly(event);
    }
  }
  onKeyPressNumberOnly(event) {
    if (event.charCode !== 32) {
      Validation.onKeyPressNumberOnly(event);
    }
  }
  onKeyPressRetrisctSomeSC(event) {
    if (event.charCode !== 32) {
      Validation.onKeyPressRetrisctSomeSC(event);
    }
  }

  camelCaseString(string) {
    let words = string.trim().split(" ");

    let result = "";

    for (let i = 0; i < words.length; i++) {
      if (words[i] !== "") {
        result =
          result +
          " " +
          words[i][0].toUpperCase() +
          words[i].substring(1).toLowerCase();
      }
    }

    return result;
  }

  onContactSubmit(values) {
    console.log(values);

    let fields = {
      name: this.camelCaseString(values.name),
      emailAddress: values.emailAddress,
      contactNumber: values.contactNumber,
      message: values.message,
    };

    ApiService.createContact(fields)
      .then((response) => {
        this.setState({
          modal_success: !this.state.modal_success,
          message:
            "We have received your message! Thank you for Contacting. We will get back to you soon.",
        });
      })
      .catch((error) => {
        this.setState({
          modal_failure: !this.state.modal_failure,
          message: "Something Went Wrong! Please Try Again",
        });
      });
  }

  refresh(event) {
    window.location.reload();
  }

  render() {
    let { name, emailAddress, contactNumber, message } = this.state;
    return (
      <div>
        <MetaTags>
          <title>
            Contact Us - Keep in touch | Ekathva Innovations Pvt Ltd
          </title>
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          ></meta>
        </MetaTags>

        <Navbar />
        <LandingPageContact />

        <div className="homepage_spacing">
          <div className="aboutus_mainspace">
            <br />
            <Row>
              <Col>
                <h3>
                  <span className="aboutus_fontbold">Locate </span> Us
                </h3>
                <br />

                <div>
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3871.878447877078!2d75.577677!3d13.96584!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x52cfb826cb1dda25!2sEkathva%20Innovations%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1614315700962!5m2!1sen!2sin"
                    className="contactus_iframesize"
                    allowfullscreen=""
                    loading="lazy"
                  ></iframe>
                </div>
              </Col>

              <Col data-aos="fade-left" data-aos-duration="1000">
                <div>
                  <h3>
                    <span className="aboutus_fontbold">Contact </span>Us
                  </h3>
                  <br />
                  <Media>
                    <Office className="contact-us-office-logo align-self-center mr-3 contactus_officelogo svgcolor contactus_logodisplay" />
                    <Media.Body
                      data-aos="fade-right"
                      className="successstories_mediapadding"
                    >
                      1st Cross, <br />
                      Hosamane, Shivamogga,
                      <br />
                      Karnataka - 577201
                    </Media.Body>
                  </Media>
                  <br />
                  <Media>
                    <Phone className="contact-us-phone-logo align-self-start mr-3 svgcolor contactus_contactlogo contactus_logodisplay" />
                    <Media.Body className="successstories_mediapadding">
                      <a
                        href="tel:+91 96638 05228"
                        className="contactus_mobsize"
                      >
                        +91 96638 05228
                      </a>
                    </Media.Body>
                  </Media>
                  <br />

                  <Media>
                    <Email className="contact-us-email-logo align-self-start mr-3 svgcolor contactus_contactlogo contactus_logodisplay" />
                    <Media.Body className="successstories_mediapadding">
                      <a
                        href="mailto:support@ekathvainnovations.com"
                        className="successstories_mailcolor"
                      >
                        support@ekathvainnovations.com
                      </a>
                    </Media.Body>
                  </Media>
                  <br />

                  <Row>
                    <Col>
                      <p>
                        <strong>Recognised by:</strong>
                      </p>
                      <Row>
                        <Col>
                          <img
                            src={SI}
                            alt="Startup India Logo"
                            className="successstories_SIimage"
                          />
                          <img
                            src={SK}
                            alt="Startup Karnataka Logo"
                            className="successstories_SKimage"
                          />
                        </Col>
                      </Row>
                    </Col>

                    <Col>
                      <p>
                        <strong>Incubated at:</strong>
                      </p>
                      <img
                        src={DS}
                        alt="Deshpande Startup Logo"
                        className="successstories_SIimage"
                      />
                      <br />
                      <img
                        src={Anvesana}
                        alt="NIAM Logo"
                        className="successstories_JNNCEimage"
                      />
                    </Col>

                    <Col>
                      <p>
                        <strong>Supported by:</strong>
                      </p>
                      <img src={JNNCE} className="successstories_JNNCEimage" />
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
            <br />
            <br />
          </div>

          {/* <Row>
            <Col>
              <div className="successstories_formspacing">
                <h2 className="successstories_textalign">
                  Keep in <span className="aboutus_fontbold"> Touch</span>
                </h2>
                <br />

                <Container data-aos="fade-right">
                  <Formik
                    onSubmit={this.onContactSubmit}
                    initialValues={{
                      name,
                      emailAddress,
                      contactNumber,
                      message,
                    }}
                    validateOnChange={false}
                    validateOnBlur={false}
                    enableReinitialize={true}
                    onChange={this.handleChange}
                  >
                    <Form>
                      <Row>
                        <Col md={2}>
                          <label>
                            Name<span className="register_page_marker">*</span>
                          </label>
                        </Col>
                        <Col md={4}>
                          <Input
                            className="capitalize"
                            name="name"
                            type="text"
                            onKeyPress={(event) => {
                              this.onKeyPressTextOnly(event);
                            }}
                            onChange={this.handleChange}
                            placeholder="Enter Your Name"
                            minLength="2"
                            maxLength="200"
                            required
                          />
                        </Col>
                      </Row>
                      <br />
                      <Row>
                        <Col md={2}>
                          <label>
                            Contact Number
                            <span className="register_page_marker">*</span>
                          </label>
                        </Col>
                        <Col md={4} className="text-center">
                          <Input
                            name="contactNumber"
                            type="text"
                            minLength="10"
                            maxLength="10"
                            placeholder="Enter Your Contact Number"
                            onChange={this.handleChange}
                            onKeyPress={(event) => {
                              this.onKeyPressNumberOnly(event);
                            }}
                            required
                          />
                        </Col>
                        <Col md={2}>
                          <label>
                            Email Address
                            <span className="register_page_marker">*</span>
                          </label>
                        </Col>
                        <Col md={4} className="text-center">
                          <Input
                            name="emailAddress"
                            type="email"
                            onChange={this.handleChange}
                            placeholder="Enter Your Email"
                            onKeyPress={(event) => {
                              this.onKeyPressRetrisctSomeSC(event);
                            }}
                            maxLength="200"
                            minLength="10"
                            required
                          />
                        </Col>
                      </Row>
                      <br />
                      <Row>
                        <Col md={2}>
                          <label>
                            Message
                            <span className="register_page_marker">*</span>
                          </label>
                        </Col>
                        <Col md={10} className="text-center">
                          <Input
                            placeholder="Enter Your Message"
                            name="message"
                            maxLength="200"
                            type="textarea"
                            rows="2"
                            onChange={this.handleChange}
                            onKeyPress={(event) => {
                              this.onKeyPressRetrisctSomeSC(event);
                            }}
                            required
                          />
                        </Col>
                      </Row>

                      <Row>
                        <Col md={2}></Col>
                        <Col md={2}>
                          <Button variant="outline-danger" type="submit">
                            Submit
                          </Button>
                        </Col>
                        <Col md={2}>
                          <Button
                            variant="outline-dark"
                            type="button"
                            onClick={this.refresh}
                          >
                            Clear
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </Formik>
                </Container>
              </div>
              <br />
            </Col>
          </Row> */}
          <br />
        </div>

        {/*Success Modal */}
        <Modal
          show={this.state.modal_success}
          backdrop="static"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="modal_alert"
        >
          <Modal.Body className="modalBody">
            <div className="aboutus_textalign">
              <img
                src={successImage}
                width="8%"
                alt="ekathvainnovations.com"
              ></img>
              <br />
              <br />
              <h4 className="aboutus_textalign">
                <strong> Success! </strong>
              </h4>
              <br />
              <br />
              <h6 className="aboutus_textalign">{this.state.message}</h6>
              <br />
              <Button
                type="button"
                variant="outline-danger"
                onClick={this.toggle("success")}
              >
                OK
              </Button>
            </div>
            <br />
          </Modal.Body>
        </Modal>

        {/*Failure Modal */}
        <Modal
          show={this.state.modal_failure}
          backdrop="static"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="modal_alert"
        >
          <Modal.Body className="modalBody">
            <div className="aboutus_textalign">
              <img
                src={failureImage}
                width="8%"
                alt="ekathvainnovations.com"
              ></img>
              <br />
              <br />
              <h4 className="aboutus_textalign">
                <strong> Failure! </strong>
              </h4>
              <br />
              <br />
              <h6 className="aboutus_textalign">{this.state.message}</h6>
              <br />
              <Button
                type="button"
                variant="outline-danger"
                onClick={this.toggle("failure")}
              >
                OK
              </Button>
            </div>
            <br />
          </Modal.Body>
        </Modal>

        <Footer />
      </div>
    );
  }
}

export default ContactUsPage;
